export class StripeBaseData{
    public id: string;
    public object: string;
    public active: boolean;
    public metadata: any;
    public created: string;
    public deleted: boolean;
    public url: string;
}